export const PROFILE = {
  name: "Faith Ahyi-Sena",
  firstName: "Faith",
  lastName: "Ahyi-Sena",
  position: "Middle Blocker",
  classYear: 2027,
  height: "6'1\"",
  weight: "150 lbs",
  school: "The Westminster Schools",
  schoolShort: "Westminster Wildcats",
  schoolLocation: "Atlanta, GA",
  schoolJersey: 6,
  schoolCoach: { name: "Jaime Maxey", email: "jaimemaxey@westminster.net", title: "Westminster Head Coach" },
  club: "A5 Volleyball Club",
  clubTeam: "17-2 Angel",
  clubLocation: "Roswell, GA",
  clubJersey: 31,
  clubCoach: { name: "Angel Gonzalez", email: "agescobales@gmail.com", title: "A5 17-2 Head Coach" },
  gpa: "3.7",
  act: "31",
  major: "Psychology",
  honorRoll: "Westminster Academic Honor Roll",
  usavId: "4392039",
  aauId: "W54CD5A5",
  apClasses: [
    "AP World History",
    "AP Computer Science Principles",
    "AP French Language & Culture",
    "AP English Literature & Composition",
  ],
  extracurriculars: [
    "2027 Grade Chair",
    "Black Affinity Group",
    "Neuro-Diverse Affinity",
    "Christian Life Council",
    "MedCats",
  ],
  clubLogo: "https://customer-assets.emergentagent.com/job_asena-d1-athlete/artifacts/95x77bqf_a5_pure_volleyball_logo.png",
  schoolLogo: "https://customer-assets.emergentagent.com/job_asena-d1-athlete/artifacts/y7iyl2so_Wildcat_Logo-removebg-preview.png",
  email: "faithahyisena.volleyball@gmail.com",
  measurables: [
    { label: "Approach Jump", value: "10'2\"", testid: "stat-approach" },
    { label: "Block Jump", value: "9'10\"", testid: "stat-block" },
    { label: "Standing Reach", value: "8'0\"", testid: "stat-reach" },
    { label: "Weight", value: "150 LB", testid: "stat-weight" },
  ],
  awards: [
    { year: "2025", title: "AVCA Phenom" },
    { year: "2025", title: "GHSA State Final Four", note: "Westminster Wildcats" },
    { year: "2024", title: "AVCA Phenom" },
    { year: "2024", title: "All-Region" },
    { year: "2023", title: "Most Improved" },
  ],
  tournaments: [
    "Triple Crown NIT",
    "NorthEast Qualifier — 5th",
    "Sunshine Qualifier — 5th",
    "Big South Qualifier — 9th",
    "Salt Lake City Qualifier — 13th",
    "SRVA Regionals — 1st",
  ],
  reelUrl: "https://www.youtube.com/watch?v=n0AkwYEblX8",
  upcoming: [
    {
      name: "Southern Exposure",
      start: "May 30, 2026",
      end: "May 31, 2026",
      venue: "Cobb Galleria",
      city: "Atlanta, GA",
    },
    {
      name: "AAU Nationals",
      start: "Jun 24, 2026",
      end: "Jun 27, 2026",
      venue: "Orange County Convention Center",
      city: "Orlando, FL",
    },
    {
      name: "USAV Nationals",
      start: "Jun 25, 2026",
      end: "Jul 3, 2026",
      venue: "Indiana Convention Center",
      city: "Indianapolis, IN",
    },
  ],
  press: [
    {
      outlet: "PrepDig",
      date: "Apr 2026",
      title: "Big South 17s: Middles Elevating Tempo and Closing the Net",
      url: "https://prepdig.com/2026/04/big-south-17s-middles-elevating-tempo-and-closing-the-net",
    },
    {
      outlet: "PrepDig",
      date: "Jan 2026",
      title: "6 Middles Scoring Fast and Owning the Net at Little Big South",
      url: "https://prepdig.com/2026/01/6-middles-scoring-fast-and-owning-the-net-at-little-big-south/",
    },
    {
      outlet: "PrepDig",
      date: "Jan 2026",
      title: "Middles Who Bring the Pressure Every Play at Little Big South",
      url: "https://prepdig.com/2026/01/middles-who-bring-the-pressure-every-play-at-little-big-south/",
    },
  ],
  profiles: [
    { label: "University Athlete Profile", url: "https://universityathlete.com/p/athlete/6yguw0ga" },
    { label: "Sports Recruits Profile", url: "https://my.sportsrecruits.com/athlete/faith_ahyi_sena2" },
    { label: "Field Level Profile", url: "https://www.fieldlevel.com/app/profile/faith.ahyisena/volleyballwomen?m=3" },
    { label: "VBall Recruiter Profile", url: "https://portal.vballrecruiter.com/players/69f2cbd553d056d5b2564e79" },
    { label: "PrepDig Profile", url: "https://prepdig.com/player/faith-ahyi-sena" },
    { label: "Hudl — Game Film", url: "https://www.hudl.com/profile/18912439/Faith-AhyiSena" },
    { label: "MaxPreps — Stats & Schedule", url: "https://www.maxpreps.com/ga/atlanta/westminster-wildcats/athletes/faith-ahyi-sena/?careerid=okq7hmguk6ptd" },
    { label: "Instagram — @faith.ahyisena.vball", url: "https://www.instagram.com/faith.ahyisena.vball" },
    { label: "YouTube — Highlight Reels", url: "https://www.youtube.com/@FaithAhyiVball" },
  ],
  images: {
    hero: "https://customer-assets.emergentagent.com/job_asena-d1-athlete/artifacts/1umop39r_Faith_Ahyi-Sena__Profile_pic.jpg",
    action: "https://customer-assets.emergentagent.com/job_asena-d1-athlete/artifacts/i5fjnm10_IMG-20260115-WA0034.jpg",
    ball: "https://customer-assets.emergentagent.com/job_asena-d1-athlete/artifacts/8sgqio2p_IMG-20260115-WA0033.jpg",
    team: "https://customer-assets.emergentagent.com/job_asena-d1-athlete/artifacts/9f7l6kp4_IMG-20260113-WA0033.jpg",
  },
  bio: `My name is Faith Ahyi-Sena. I'm a 6'1" Middle Blocker at The Westminster Schools in Atlanta, GA, graduating in the Class of 2027. I've been playing volleyball since I was 13, and honestly it's become one of the most important parts of my life. It's where I've figured out how to push through hard things, how to be a better teammate, and how to compete at a high level.

I play club with A5 Volleyball Club's 17-2 Angel in Roswell, GA — it's one of the top club programs in the country and being part of it has really pushed me to grow. This season we competed at the Triple Crown NIT, the National Elite Qualifier (5), the Sunshine Classic (5) and the Nike Big South (7).

At Westminster, I have found community among my peers and teachers over the past 11 years. With the Westminster Wildcats volleyball team, we made the Final Four at the 2025 Georgia State Championship. I've earned a few individual awards along the way — AVCA Phenom in 2024 and 2025, All-Region in 2024, and Most Improved in 2023. But honestly what I'm most proud of is how much I've improved by just putting in the work every day.

In the classroom, I am a consistent member of the Academic Honor Roll at Westminster and I plan to major in Psychology in college. I'm looking for a program where academic excellence and athletic excellence go hand in hand.

Beyond volleyball, I am grounded in my Christian faith, which shapes how I compete, how I lead, and how I treat my teammates and classmates. I also love reading, spending time outdoors, and jewelry making.

I am seeking a program where I can contribute immediately as a middle blocker while continuing to grow into the best version of myself. I am coachable, driven, and I can't wait to see what God has in store for my future!`,
};
